import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { catchError } from 'rxjs/operators'
import { firstValueFrom } from 'rxjs'

@Injectable()
export class LocaleService {
  currentLocale = 'en'

  get locale() {
    return this.currentLocale
  }

  constructor(private translateService: TranslateService) {
    if (navigator.language.split('-')[0] === 'es') {
      this.currentLocale = 'es'
    }
  }

  async translate(text: string): Promise<string> {
    return firstValueFrom(
      this.translateService.get(text).pipe(catchError(() => '')),
    )
  }

  instant(text: string): string {
    return this.translateService.instant(text)
  }
}
